import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";
import React from "react";

export const stringArrayToTags = (arr: string[]) => {
  return (
    <div style={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      {arr.map((ob, key) => {
        let truncatedString = ob;
        if (truncatedString.length > 12) {
          truncatedString = `${ob.substring(0, 12)}...`;
        }

        return (
          <div key={key}>
            <Tooltip target=".tag-tooltip" />
            <Tag value={truncatedString} className="tag-tooltip" data-pr-tooltip={ob} rounded />
          </div>
        );
      })}
    </div>
  );
};
